import React from 'react';
import { Link } from 'react-router-dom';

const PartnerThankYouPage = () => {
  return (
    <main className="thank-you-page">
      <section className="thank-you-card">
        <p className="eyebrow">Partner request received</p>

        <h1>Thank you — we received your partner request.</h1>

        <p>
          We’ll review your business details and follow up about listing your
          experience on Teamward.
        </p>

        <div className="thank-you-next">
          <h3>What happens next?</h3>

          <ul>
            <li>We review your business, location, and experience details.</li>
            <li>We look at whether your offering is a good fit for team outings.</li>
            <li>We follow up by email with next steps.</li>
          </ul>
        </div>

        <p>
          Most partner requests are reviewed within{' '}
          <strong>1 business day</strong>.
        </p>

        <div className="thank-you-actions">
          <Link to="/" className="button primary">
            Return to Teamward
          </Link>

          <Link to="/" className="button secondary">
            Browse Experiences
          </Link>
        </div>
      </section>
    </main>
  );
};

export default PartnerThankYouPage;
